import React, { Fragment, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { spinnerOff, spinnerOn } from '../../components/Spinner';
import { post } from '../../api';

import IpsFMPProjectGrid from '../../components/ProjectsGrid/IpsFMPProjectGrid';

import IpsFMPProjectList from 'components/ProjectsList/IpsFMPProjectList';
import IPSFMPViewType from 'components/ViewType/IPSFMPViewType';
import { directToProject } from '../../utils/Dashboard';
import completeData from './complete.json'

export default withRouter(function FMPTrackerComplete(props) {
  const { context, history, cardview, onViewTypeChange, projectList } = props;

  const [projects, setProjects] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    async function getProjects() {
      if (projects && projects.length < 1) {
        spinnerOn();
        setIsLoading(true);

        const result = await post(`fmpprojects/complete`, '', {});

        setProjects(result.data);

        spinnerOff();
        setIsLoading(false);
      }
    }

    getProjects();
  }, []);

  function goToProject(project) {
    

    directToProject(project,history,'fmptracker_complete',context)
  }
  return (
    <Fragment>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flewGrow: 1,
          justifyContent: 'center',
          paddingRight: '16px',
          paddingBottom: '16px',
        }}
      >
        <div style={{ flexGrow: 1 }} />
        <IPSFMPViewType
          onViewTypeChange={onViewTypeChange}
          tabView={'FMP_C'}
          tstatus={'FMP_C'}
        />
      </div>
      {cardview === 'cardview' ? (
        <IpsFMPProjectGrid
          projects={projectList(projects)}
          history={history}
          context={context}
          onButtonClick={goToProject}
          isLoading={isLoading}
          {...props}
        />
      ) : (
        <IpsFMPProjectList
          projects={projectList(projects)}
          onButtonClick={goToProject}
          {...props}
        />
      )}
      {}
    </Fragment>
  );
});